/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const ComputeInstanceState = {
  Requested: "requested",
  Starting: "starting",
  Running: "running",
  Ready: "ready",
  Busy: "busy",
  Stopping: "stopping",
  Stopped: "stopped",
  Succeeded: "succeeded",
  Failed: "failed",
  Lost: "lost",
  Unknown: "unknown",
} as const;
export type ComputeInstanceState = ClosedEnum<typeof ComputeInstanceState>;

/** @internal */
export const ComputeInstanceState$inboundSchema: z.ZodNativeEnum<
  typeof ComputeInstanceState
> = z.nativeEnum(ComputeInstanceState);
/** @internal */
export const ComputeInstanceState$outboundSchema: z.ZodNativeEnum<
  typeof ComputeInstanceState
> = ComputeInstanceState$inboundSchema;
